import React, { PureComponent } from 'react'
import { pageData } from 'decorators'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import AuthActions from 'store/redux/auth'
import MockActions from 'store/redux/mocks'
import McActions from 'store/redux/mc'
import MOCK_GAME_DATA from 'data/mocks/mc/game.json'
import { Button } from 'components'
import GameTemplate from '../templates/GameTemplate'
import './App.css'

@pageData({ title: 'App' })
@connect(
    null,
    {
        signout: AuthActions.signout,
        cleanData: MockActions.cleanData,
        simulatePreSeason: MockActions.simulatePreSeason,
        simulatePreRace: MockActions.simulatePreRace,
        simulateRace: MockActions.simulateRace,
        simulatePostRace: MockActions.simulatePostRace,
        simulatePostSeason: MockActions.simulatePostSeason,
        handleGameData: McActions.handleGameData,
        navigate: push
    }
)
export class App extends PureComponent {
    componentWillMount() {
        this.props.signout(false)
        this.props.cleanData()
    }
    handleNewGame = () => {
        this.props.signout(false)
        this.props.navigate('/new-game')
    }
    handleMC = () => {
        this.props.signout(false)
        this.props.navigate('/mc/signin')
        // this.props.handleGameData({ ok: true, data: MOCK_GAME_DATA })
    }
    handleAdmin = () => {
        this.props.signout(false)
        this.props.navigate('/admin/signin')
    }
    render() {
        const { simulatePreSeason, simulatePreRace, simulateRace, simulatePostRace, simulatePostSeason } = this.props
        return (
            <GameTemplate className="App">
                <div className="flex col-center" style={{ height: '100%' }}>
                    <div className="flex row-center pb-5">
                        <Button color="primary" className="m-10p" onClick={this.handleNewGame}>
                            NEW GAME
                        </Button>
                    </div>
                    <div className="flex row-center py-5">
                        <Button color="primary" className="m-10p" onClick={simulatePreSeason}>
                            PRE-SEASON
                        </Button>
                        <Button color="primary" className="m-10p" onClick={simulatePreRace}>
                            PRE-RACE
                        </Button>
                        <Button color="primary" className="m-10p" onClick={simulateRace}>
                            RACE
                        </Button>
                        <Button color="primary" className="m-10p" onClick={simulatePostRace}>
                            POST-RACE
                        </Button>
                        <Button color="primary" className="m-10p" onClick={simulatePostSeason}>
                            POST-SEASON
                        </Button>
                    </div>
                    <div className="flex row-center py-5">
                        <Button color="primary" className="m-10p" onClick={this.handleMC}>
                            MC Panel
                        </Button>
                        <Button color="primary" className="m-10p" onClick={this.handleAdmin}>
                            Admin Panel
                        </Button>
                    </div>
                </div>
            </GameTemplate>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/App/App.js